import { WorkflowStatus } from "modules/api/types/WorkflowPayload";

const actionCategories = {
  ok: [WorkflowStatus.DOCUMENTS_READY],
  warn: [WorkflowStatus.PAYMENT_REQUIRED],
  alert: [WorkflowStatus.AWAITING_LAWYER_REVIEW],
};

export default actionCategories;
